<template>
  <div class="not-found container">
    <span
      class="title-404 font-roboto-mono d-flex font-weight-lighter m-auto text-center mb-5 p-4"
    >
      401
    </span>
    <h1 class="text-center mt-5">
      Not Authorized
    </h1>
  </div>
</template>

<script>
export default {

  computed: {
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/components/not-found.scss';
</style>
